import { useAlert } from 'react-alert';
import { Button, Form, OverlayTrigger, Popover } from 'react-bootstrap';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useSelector } from 'react-redux';
import I18n from 'i18n-js';
import { node } from 'prop-types';

import Alert from '~/components/Alert';

import { useRedirectToLogin } from '~/hooks/useRedirectToLogin';
import { userSelector } from '~/redux/selectors';

const RecruitPopup = ({ children }) => {
  const redirectToLogin = useRedirectToLogin();

  const { username } = useSelector(userSelector);
  const alert = useAlert();
  const encodedUsername = encodeURIComponent(username || '');
  const host =
    window.location.href &&
    window.location.href.indexOf('www.lootboy.com') !== -1
      ? 'www.lootboy.com'
      : 'www.lootboy.de';
  const recruitmentUrl = `https://${host}/recruit?u=${encodedUsername}`;
  const shareText = `${I18n.t(
    'common_recruit_message_text',
  )}\n${recruitmentUrl}`;
  const overlay = (
    <Popover className="recruitPopup">
      <Popover.Title>{I18n.t('Recruit_Popup_title')}</Popover.Title>
      <Popover.Content>
        {I18n.t('Recruit_Popup_header')}
        <Form.Control
          as="textarea"
          readOnly
          value={shareText}
        />
        <CopyToClipboard
          onCopy={() =>
            alert.info(
              <Alert
                body={I18n.t('common_copied_to_clipboard_msg')}
                title={I18n.t('common_copied_to_clipboard_title')}
              />,
            )
          }
          text={shareText}
        >
          <Button variant="primary">
            {I18n.t('common_copy_to_clipboard')}
          </Button>
        </CopyToClipboard>
      </Popover.Content>
    </Popover>
  );

  return (
    <OverlayTrigger
      overlay={overlay}
      placement="bottom"
      trigger="click"
      onToggle={() => {
        if (!username) {
          redirectToLogin();
        }
      }}
    >
      {/* it will porbably be redone so it pointless to make style file for it */}
      <div style={{ cursor: 'pointer' }}>{children}</div>
    </OverlayTrigger>
  );
};

RecruitPopup.propTypes = {
  children: node,
};

export default RecruitPopup;
